import { Box, Paper, Stack, TextField, Typography } from '@mui/material'
import { useCallback, useMemo } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { RO_CLOSED } from '../../../models/Status'
import {
  useGetUsersWithPermissionQuery,
  useUpdateRepairOrderMutation
} from '../../../redux/api'
import {
  GetUsersWithPermissionActEnum,
  RepairOrderExpanded,
  RepairOrderInfo
} from '../../../sdk'

export const ConcernAndNotes = ({
  repairOrder
}: {
  repairOrder: RepairOrderExpanded
}) => {
  const { accessToken, shopId, userId } = useAccessTokenAndShopId()
  const [updateRepairOrder] = useUpdateRepairOrderMutation()
  const { data: allowedUsers } = useGetUsersWithPermissionQuery({
    authorization: accessToken,
    shop: shopId,
    act: GetUsersWithPermissionActEnum.ManageRepairOrder
  })
  const isEditable = useMemo(
    () => !!allowedUsers?.find((u) => u.id === userId),
    [allowedUsers, userId]
  )
  const handleUpdateRepairOrder = useCallback(
    (key: keyof RepairOrderInfo, value: string) => {
      if (repairOrder) {
        updateRepairOrder({
          authorization: accessToken,
          repairOrderEntry: {
            ...repairOrder.entry!,
            info: {
              ...repairOrder.entry!.info!,
              [key]: value
            }
          }
        })
      }
    },
    [accessToken, repairOrder, updateRepairOrder]
  )
  return (
    <Stack spacing={2} mt={2}>
      <Paper variant="outlined">
        <Box px={2} pb={2}>
          <Typography pt={1}>
            <b>Concern</b>
          </Typography>
          <TextField
            data-testid="EstimatesConcernField"
            defaultValue={repairOrder!.entry!.info!.concern || ''}
            multiline
            minRows={2}
            maxRows={2}
            placeholder="Minimum 3 characters"
            fullWidth
            onBlur={({ target }) =>
              handleUpdateRepairOrder('concern', target.value)
            }
            disabled={repairOrder?.status?.id === RO_CLOSED || !isEditable}
          />
        </Box>
      </Paper>
      <Paper variant="outlined">
        <Box px={2} pb={2}>
          <Typography pt={1}>
            <b>Notes</b>
          </Typography>
          <TextField
            data-testid="EstimatesNotesField"
            defaultValue={repairOrder!.entry!.info!.notes || ''}
            multiline
            minRows={2}
            maxRows={2}
            fullWidth
            onBlur={({ target }) =>
              handleUpdateRepairOrder('notes', target.value)
            }
            disabled={repairOrder?.status?.id === RO_CLOSED}
          />
        </Box>
      </Paper>
    </Stack>
  )
}
